import { PartialRealisationAllocationLogic } from 'further-types/lp/realisation';
import allocateUnitsProRataStrategy from './allocateUnitsProRataStrategy';
import allocateUnitsOrderedStrategy from './allocateUnitsOrderedStrategy';
import { InvestmentHistory } from '../../types';

const getUnitsAllocation = (
  investmentHistory: InvestmentHistory,
  unitsSold: number,
  totalUnits: number,
  partialAllocationType: PartialRealisationAllocationLogic,
) => {
  switch (partialAllocationType) {
    case PartialRealisationAllocationLogic.ProRata:
      return allocateUnitsProRataStrategy(
        investmentHistory,
        unitsSold,
        totalUnits,
      );
    case PartialRealisationAllocationLogic.FIFO:
      return allocateUnitsOrderedStrategy(
        investmentHistory,
        unitsSold,
        totalUnits,
        PartialRealisationAllocationLogic.FIFO,
      );
    case PartialRealisationAllocationLogic.LIFO:
      return allocateUnitsOrderedStrategy(
        investmentHistory,
        unitsSold,
        totalUnits,
        PartialRealisationAllocationLogic.LIFO,
      );
    default:
      return {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...investmentHistory,
        allocatedUnits: unitsSold,
      };
  }
};

export default getUnitsAllocation;
